module.exports = __webpack_public_path__ + "media/bootstrap-icons/window-sidebar-74d71ef8.svg";